/* youthfulbloom - quick add.
   The + on a card opens a size row; picking a size hands off to the cart
   drawer so the add and the drawer open stay in one place. */
(function () {
  function closeAll(except) {
    document.querySelectorAll('[data-yb-sizes]').forEach(function (box) {
      if (box === except) return;
      box.hidden = true;
      var btn = box.parentNode.querySelector('[data-yb-add]');
      if (btn) btn.setAttribute('aria-expanded', 'false');
    });
  }

  var toast;
  function say(msg) {
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'yb-toast';
      document.body.appendChild(toast);
    }
    toast.textContent = msg;
    requestAnimationFrame(function () { toast.classList.add('is-up'); });
    clearTimeout(say._t);
    say._t = setTimeout(function () { toast.classList.remove('is-up'); }, 2200);
  }

  document.addEventListener('click', function (e) {
    var plus = e.target.closest('[data-yb-add]');
    if (plus) {
      e.preventDefault();
      var box = plus.parentNode.querySelector('[data-yb-sizes]');
      if (!box) return;
      var opening = box.hidden;
      closeAll(box);
      box.hidden = !opening;
      plus.setAttribute('aria-expanded', String(opening));
      return;
    }

    var size = e.target.closest('[data-yb-variant]');
    if (size) {
      e.preventDefault();
      if (size.disabled) return;

      size.disabled = true;
      closeAll();

      /* Cart drawer owns the add; fall back to a plain post if it is absent. */
      var done = (typeof window.ybCartAdd === 'function')
        ? window.ybCartAdd(size.dataset.ybVariant)
        : fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: Number(size.dataset.ybVariant), quantity: 1 }] })
          }).then(function () { say('Added to cart'); });

      Promise.resolve(done)
        .catch(function () { say('Could not add that one'); })
        .then(function () { size.disabled = false; });
      return;
    }

    if (!e.target.closest('[data-yb-sizes]')) closeAll();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAll();
  });
})();
